import { Component, OnInit, ViewChild } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ReservationsService } from '@app/shared/services/reservations.service';
import { PdfService } from '@app/shared/services/pdf.service';
import { SessionService } from '@app/shared/services/session.service';
import { AlertService } from '@app/shared/services/alert.service';
import { DateService } from '@app/shared/services/date.service';
import * as moment from 'moment';
import { UsersService } from '@app/shared/services/users.service';
import { ChangeReservationDetailsComponent } from '@app/components/modals/change-reservation-details/change-reservation-details.component';
import { RESERVATION_STATUS_NAMES } from '@app/shared/constants/reservation-status';

@Component({
    selector: 'app-reservation-informations',
    templateUrl: './reservation-informations.component.html',
    styleUrls: ['./reservation-informations.component.scss']
})
export class ReservationInformationsComponent implements OnInit {

    private sessionStatusNames = RESERVATION_STATUS_NAMES;
    public sessionStatus: string = '';
    public events: Array<any> = [];

    public routerURL: string = '/reservation/list';
    public previousUrlName: string = 'Liste des réservations'

    public id: string = '0';
    public informationForm: any;
    public reservation: any = {};
    public loading: boolean = true;
    public invoiceAvailable: boolean = false;
    public invoiceLoading: boolean = false;
    public totalAmount: number = 0;

    public entryStates: any = {
        statesOfCar: [],
        exists: false
    };

    public variousStates: any = {
        statesOfCar: [],
        exists: false
    }

    public exitStates: any = {
        statesOfCar: [],
        exists: false
    }

    public boundStates: any = {
        statesOfCar: [],
        exists: false
    }

    @ViewChild('changeDetails') changeDetails: ChangeReservationDetailsComponent;

    constructor(
        private titleService: TitleService,
        private menu: MenuService,
        private route: ActivatedRoute,
        private router: Router,
        private reservationService: ReservationsService,
        private pdfService: PdfService,
        public sessionService: SessionService,
        private alertService: AlertService,
        private dateService: DateService,
        private userService: UsersService
    ) { }

    ngOnInit() {
        this.route.queryParams
            .subscribe(params => {
                if (params.from) this.routerURL = params.from;
                if (params.name) this.previousUrlName = params.name;
            });

        this.id = this.route.snapshot.paramMap.get('id');
        this.titleService.setTitle(`Information sur la réservation / VOP`);
        this.menu.setMenuState('reservation', 'reservation', 'information');
        this.menu.id = this.id;
        this.loadInformations();
    }

    ngOnDestroy() {
        let reservations = JSON.parse(sessionStorage.getItem('ReservationList'));
        if (reservations === null) { return; }
        let index = reservations.findIndex((reservation) => reservation.Id === parseInt(this.id, 10));
        if (index === -1) { return; }

        reservations[index] = this.reservation;
        sessionStorage.setItem('ReservationList', JSON.stringify(reservations));
    }

    refreshInvoice(): void {
        this.loadInformations();
    }

    waitInvoice(): void {
        this.invoiceAvailable = false;
        this.invoiceLoading = true;
        this.reservationService.getReservation(this.id).then((res) => {
            res = this.dateService.convertToLocal(res);
            res.StatesOfCars = this.dateService.convertAlltoLocal(res.StatesOfCars);
            this.reservation = res;
            this.setSessionStatus();
            this.getStaffStatus();
            this.getEvents();
            this.loading = false;
        });
        setTimeout(() => {
            this.reservation.lastChange = moment();
            this.getInvoiceFields();
        }, 5500);
    }

    getStaffStatus(): void {
        this.userService.getUser(this.reservation.IdAccount).then((user) => {
            if (user.IdAccountDemo > 0) {
                this.reservation.demo = true;
            } else {
                this.reservation.demo = false;
            }
        });
    }

    getStatus(status): string {
        if (status == 20) {
            return 'Réservation annulée'
        }
        if (status == -1) {
            return 'Échec de pré-auto stripe'
        }
        else if (status >= 0 && status <= 14) {
            return this.sessionStatusNames[status];
        }
        else {
            return 'Status Inconnu: ' + status;
        }
    }

    getInvoiceFields(): void {
        this.invoiceAvailable = false;
        this.invoiceLoading = true;
        console.log("Id de la reservation", this.reservation.Id);
        this.reservationService.getReservationInvoiceFields(this.reservation.Id).then((res) => {
            console.log("Invoice field", res);
            this.totalAmount = 0;
            if (res && res.length > 0) {
                this.invoiceAvailable = true;
                res.forEach((line) => {
                    this.totalAmount += line.IncludingTaxes * line.Quantity;
                });
            } else {
                this.invoiceAvailable = false;
            }

            this.invoiceLoading = false;
        });
    }

    getEvents(): void {
        this.reservationService.getReservationEvents(parseInt(this.id, 10)).then((res) => {
            res = this.dateService.convertAlltoLocal(res);
            this.events = res.reverse();
            this.events.forEach((event) => {
                event.sessionStatus = this.getStatus(event.type) //this.sessionStatusNames[Math.min(event.type, 14)];
            });
        });
    }

    setSessionStatus(): void {
        if (this.reservation.Status === -1) {
            this.sessionStatus = 'Annulé';
        } else {
            this.sessionStatus = this.getStatus(this.reservation.Status) //|| this.sessionStatusNames[Math.min(this.reservation.Status, 14)];
        }
    }

    groupStatesOfCar(): void {
        this.entryStates = {
            statesOfCar: [],
            exists: false
        };
        this.variousStates = {
            statesOfCar: [],
            exists: false
        }
        this.exitStates = {
            statesOfCar: [],
            exists: false
        }
        this.reservation.StatesOfCars.forEach((state) => {
            switch (state.type) {
                case 0:
                    this.entryStates.exists = true;
                    this.entryStates.statesOfCar.push(state);
                    break;
                case 1:
                    this.variousStates.exists = true;
                    this.variousStates.statesOfCar.push(state);
                    break;
                case 2:
                    this.exitStates.exists = true;
                    this.exitStates.statesOfCar.push(state);
                    break;
            }
        });
    }

    bindStates(selectedStates) {
        this.boundStates = selectedStates;
    }

    loadInformations(): void {
        this.reservationService.getReservation(this.id).then((res) => {
            console.log(res);
            res = this.dateService.convertToLocal(res);
            res.StatesOfCars = this.dateService.convertAlltoLocal(res.StatesOfCars);
            this.reservation = res;
            this.groupStatesOfCar();
            this.setSessionStatus();
            this.getInvoiceFields();
            this.getStaffStatus();
            this.getEvents();
            this.loading = false;
        });
    }

    downloadInvoice() {
        this.reservationService.getReservationInvoice(this.reservation.Id).then((res) => {
            console.log("reservation fichier", res)
            if (res.file === null || res.filename === null) {
                this.alertService.alert(`Une erreur est survenue lors du téléchargement de la facture.`);
                return;
            }
            this.pdfService.setFile(res.file).then((file) => {
                this.pdfService.downloadFile(res.filename);
            })
        });
    }

    closeReservation(): void {
        let query = {
            closingDate: '',
            bookingCode: this.reservation.Code
        };
        this.loading = true;
        console.log("a", this.reservation.ISORealDateEnd)

        
        query.closingDate = new Date().toISOString();
           
        console.log("3", query.closingDate)
        query = this.dateService.convertToISO(query);
        this.reservationService.closeReservation(query.bookingCode, query.closingDate).then((res) => {
            console.log("reservation close", res);

            if (res && res.success === false) {
                this.alertService.alert('La clôture de la réservation a échoué.');
            }
            this.loading = false;
            this.loadInformations();
        });
    }

    deleteReservation(): void {
        this.reservationService.deleteReservation(this.id).then(() => {
            sessionStorage.removeItem('ReservationList');
            sessionStorage.removeItem('ReservationListMaxPages');
            sessionStorage.removeItem('ReservationListCurrentPage');
            sessionStorage.removeItem('ReservationListTimeout');
            this.router.navigate(['/reservation/list']);
        })
    }

    changeStatus(status) {
        this.reservationService.updateReservationStatus(this.id, parseInt(status, 10)).then(() => {
            this.loadInformations();
        });
    }
}
